import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18 21H7V8l7-7l1.25 1.25q.175.175.288.475T15.65 3.3v.35L14.45 8H21q.8 0 1.4.6T23 10v2q0 .175-.037.375t-.113.375l-3 7.05q-.225.5-.75.85T18 21M5 8v13H1V8z" })
});
export default SvgThumbUp;
